import { Box, Collapse } from "@mui/material";
import InvoiceDetails from "./InvoiceDetails";

const InvoiceHiredInformation = ({ open, data }) => {
  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Box
        maxWidth={true}
        sx={{
          margin: 1,
          backgroundColor: "#FFF",
          borderRadius: "4px",
          padding: "0px 24px",
        }}
      >
        {data.receivables.map((receivable) => {
          return (
            <InvoiceDetails key={receivable.uuid} receivable={receivable} />
          );
        })}
      </Box>
    </Collapse>
  );
};

export default InvoiceHiredInformation;
